import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaSmile,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const UserExperienceFocusedEcommerceWebsitesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="User-Experience Focused E-commerce Websites in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Delight Your Customers</Subheading>}
        heading={
          <Heading>
            User-Experience Focused{" "}
            <span tw="text-primary-500">E-commerce Websites</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we craft user-experience focused e-commerce
            websites in **DIFC**, designed to captivate and convert with
            intuitive navigation and delightful interactions. Create a store
            that customers love to explore.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1555421689-491a97ff2040?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Design for UX"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Exceptional UX Design in DIFC"
        description="We prioritize user satisfaction in every e-commerce website."
        cards={[
          {
            icon: <FaSmile color="#ff5464" size={40} />,
            title: "Intuitive Navigation",
            description: "Effortless browsing for happy customers.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion-Driven",
            description: "Layouts that guide users to purchase.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Visuals",
            description: "Aesthetics that captivate and retain.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Smooth Performance",
            description: "Fast, responsive designs for UX.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Perfection",
            description: "Seamless experience on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by DIFC",
            description: "Top choice for UX-focused e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our UX-Focused Design Process"
        description={
          <Description>
            We create user-experience focused e-commerce websites with a
            thoughtful approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Understand your audience and goals.</li>
              <li>Design: Develop user-friendly, engaging layouts.</li>
              <li>Development: Build with UX at the core.</li>
              <li>Testing: Validate ease of use and functionality.</li>
              <li>Launch: Deliver a store users love.</li>
              <li>Support: Optimize based on user feedback.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1574717024453-354056afd83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="UX Wins in DIFC"
        description="Our designs have elevated user satisfaction."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Higher Conversions",
            description: "Increased sales with intuitive UX.",
          },
          {
            icon: <FaSmile color="#ff5464" size={40} />,
            title: "User Retention",
            description: "Boosted engagement for DIFC stores.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "98% approval for UX excellence.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Great UX?</Subheading>}
        heading="UX-Focused E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for user-experience focused e-commerce
            website design in DIFC. Build a store that delights and
            converts—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531403009284-440f080d1e12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1603969072881-b0fc7f3d77d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
